import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import React from 'react';

interface Props {
  previous?: string | null;
  next?: string | null;
  onChange: (cursor: string | null) => void;
}

const btnStyle: React.CSSProperties = {
  background: 'transparent',
  border: 'none',
  boxShadow: 'none',
};

const CursorPagination: React.FC<Props> = ({ previous, next, onChange }) => (
  <Button.Group>
    <Button
      data-testid="pag-prev"
      style={btnStyle}
      icon={<LeftOutlined />}
      disabled={!previous}
      onClick={() => onChange(previous ?? null)}
    />
    <Button
      data-testid="pag-next"
      style={btnStyle}
      icon={<RightOutlined />}
      disabled={!next}
      onClick={() => onChange(next ?? null)}
    />
  </Button.Group>
);

export default CursorPagination;
